import { useQuery } from '@apollo/client';
//import { BookmarkSquareIcon } from '@heroicons/react/24/outline';
import { EllipsisVerticalIcon, PaperClipIcon, PencilIcon, BookmarkSquareIcon } from '@heroicons/react/24/solid';
import { CalendarDateIcon, EventConfirmIcon } from 'assets/icons';
import Button from 'components/Button/Button';
import Flyout, { useFlyout } from 'components/Flyout/Flyout';
import { Table } from 'components/Table/Table';
import { GetLogbookDocument } from 'graphql/generated';
import { Fragment, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatApiDate } from 'utils/formatter';
import New from '../Entries/New';
import Card from 'components/Card/Card';
import Edit from '../Edit';
import View from '../Entries/View';
import { Menu, Transition } from '@headlessui/react';
import isMobileApp from 'utils/isMobileApp';
import Header from 'components/Header/Header';
import CogMenu from 'components/CogMenu/CogMenu';
import ThumbButton from 'components/ThumbButton/ThumbButton';

const stripHtmlTags = (htmlString) => {
  // Create a temporary div element to hold the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  
  // Get the text content of the div, which will not include any HTML tags
  return tempDiv.textContent || tempDiv.innerText || "";
};

const Logbook = function () {
  const logBookId = useParams()?.logbookId;
  const { data : { logBook } = { } } = useQuery(GetLogbookDocument, { variables: { logBookId } });
  const logEntries =logBook?.logEntries;
  const { flyoutProps, closeFlyout, updateFlyout } = useFlyout();
  const columns = useMemo(() => {
    return [
      {
        Header: 'Title',
        accessor: 'title',
        className: 'w-2/6',
      },
      {
        Header: 'Description',
        accessor: 'description',
        className: 'w-3/6 truncate px-2 max-w-lg max-h-10',
        Cell: ({ cell: { value } }) => (
          <>{stripHtmlTags(value)}</>
        ),
      },
      {
        Header: 'Date',
        accessor: 'logDate',
        className: 'w-1/6',
        Cell: ({ cell: { value } }) => (
          <div className="flex items-center">
            <CalendarDateIcon className="h-3 w-3 mr-1" />
            <span>{formatApiDate(value)}</span>
          </div>
        ),
      },
    ];
  }, []);
  const menuItems = [
    {
      webAction: async () => { updateFlyout({ title: 'Edit Logbook', content: <Edit id={logBookId} closeFlyout={closeFlyout} /> })},
      name: 'Edit',
      webOnly: false,
    },
    {
      mobileAction: async () => { await navigator.share({ title:"Export Flights from Coflyt", url: process.env.REACT_APP_API_URL+"/logbooks/"+logBookId , text: "Export Logbook from Coflyt"}) },
      webAction: process.env.REACT_APP_API_URL+"/logbooks/"+logBookId,
      name: 'Export',
      webOnly: false,
    }
  ]

  if (!logEntries) return null;

  return (
    <>
      <Flyout {...flyoutProps} />
      <div className="flex flex-col w-full">
        {/* Header */}
        <Header title={logBook.name} subtitle={logBook?.description} icon={EventConfirmIcon}>
          <div className="flex items-stretch gap-2">
            <Button text="New Entry" color="navy" size="xs" className="hidden md:flex" icon={<BookmarkSquareIcon className="h-4 w-4 -ml-1 mr-1 stroke-[0.15rem]" />} onClick={ () => updateFlyout({ title: 'New Entry', content: <New id={logBookId} closeFlyout={closeFlyout} /> }) } />
            <CogMenu items={menuItems} />
            <ThumbButton size="primary" role="add" onClick={ () => updateFlyout({ title: 'New Entry', content: <New id={logBookId} closeFlyout={closeFlyout} /> }) }/>
          </div>
        </Header>
        <div className="bg-white border border-slate-300 rounded p-2 md:p-6">
          {logEntries?.length === 0 
            ? <div className="flex justify-center items-center p-6">
                  <h1 className="text-center text-slate-500">No Logs Found</h1>
              </div>
            : <Table
                data={logEntries}
                columns={columns}
                className='w-full'
                onRowClick={(row) => {
                  updateFlyout({ title: row.title, content: <View closeFlyout={closeFlyout} id={row.id} /> });
                }}
              />
          }
        </div>
      </div>
    </>
  );
};

export default Logbook;
